export const getCSSVarValue = (key: string, node: Element | null = null): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const element = node || window.document.getElementById('root') || window.document.body;

  if (!element) {
    return '';
  }

  const computedStyle = window.getComputedStyle(element);

  if (!computedStyle) {
    return '';
  }

  return computedStyle.getPropertyValue(key);
};

export const getCSSNumberValue = (key: string, node?: Element | null): number => {
  return parseInt(getCSSVarValue(key, node) || '0', 10) || 0;
};
